import React, { useState } from 'react';
import { AppButton } from '@common-fe/common-fe';

import useEmployerTerminationBanner from '@/modules/core/hooks/useEmployerTerminationBanner';
import { ButtonHintForTerminatedEmployer } from '@/modules/employer/components/EmployerTermination/ButtonHintForTerminatedEmployer';

import { AddDependentModal } from './AddDependentModal';

export const DependentsAddButton = () => {
  const [visible, setVisible] = useState(false);
  const { isLimitedUseWhileTerminationInProgress } = useEmployerTerminationBanner();

  return (
    <>
      <ButtonHintForTerminatedEmployer
        button={
          <AppButton
            testId="DependentsHeader-add_dependent"
            onClick={() => setVisible(true)}
            width="150px"
            disabled={isLimitedUseWhileTerminationInProgress}
            buttonType="secondary"
          >
            Add Dependent
          </AppButton>
        }
        isTerminatedEmployer={isLimitedUseWhileTerminationInProgress}
        hintText='Terminated Organization cannot add dependent'
      />
      <AddDependentModal visible={visible} onSetVisible={setVisible} />
    </>
  );
};

export default DependentsAddButton;
